<template>
    <canvas class="canvas" :id="id" width="280" height="65"></canvas>
</template>
<script>
export default {
    name: "left",
    props: {
        dataArry:{
            type: Array | Object
        },
        id:{
            type:String
        },
        colorArr:{
            type: Array | Object
        }
    },
    data() {
        return {
        }
    },
    mounted() {
        let that = this
        that.$nextTick(()=> {
            //console.log(that.chartData)
           that.drawLine();
        })
    },
    watch: {
        'dataArray': function () {
            this.drawLine();
        }
    },
    created() {
		
    },
    methods: {
        // 划线
        drawLine () {
            let that = this;
            let ctx = document.getElementById(that.id).getContext("2d");  
            let value = that.dataArry;
            let max = Math.max(...value);
            let h = 65;
            let w = 280;
            let len = value.length;
            let hBase = 0;
            if(max != 0){
                hBase = 65/max;
            }
            let wBase = 280/(len - 1);
            let arr = [];
            for(let i in value){
                arr.push({
                    'x':i*wBase,
                    'y':65-value[i]*hBase
                })
            }
            ctx.beginPath();   
            ctx.strokeStyle=that.colorArr[0]; 
            ctx.lineWidth='2';
            if(arr.length <= 0){
                return;
            }
            ctx.moveTo(arr[0].x, arr[0].y);//起始位置
            for(let j in arr){
                if(j%2 == 0 && j > 0){
                    ctx.quadraticCurveTo(arr[j-1].x, arr[j-1].y, arr[j].x, arr[j].y)
                }
            } 
            ctx.stroke(); 
            ctx.beginPath();   
            ctx.strokeStyle="rgba(0,0,0,0)"; 
            ctx.lineWidth='0';
            ctx.moveTo(arr[0].x, arr[0].y);//起始位置
            for(let j in arr){
                if(j%2 == 0 && j > 0){
                    ctx.quadraticCurveTo(arr[j-1].x, arr[j-1].y, arr[j].x, arr[j].y)
                }
            }  
            ctx.lineTo(280,65);
            ctx.lineTo(0,65);
            ctx.closePath();
            let grd=ctx.createLinearGradient(0,0,0,65);
            grd.addColorStop(0,that.colorArr[1]);
            grd.addColorStop(1,that.colorArr[2]);

            ctx.fillStyle=grd; 
            ctx.fill();
            ctx.stroke();
        }
	}
}
</script>
<style lang="">
    
</style>



// WEBPACK FOOTER //
// src/components/homeLine.vue